import { VirtualObjectType } from '@spazious/dollhouse-graphql';
import { VirtualObject } from '@spazious/react-booking-engine';

export const mapDecoration = ({ id, attributes }: VirtualObject) => ({
  id: attributes!.uuid!.toString(),
  nid: parseInt(id.toString()),
  name: attributes!.name,
  model: attributes!.asset as any as string,
  type: VirtualObjectType.Decoration,
  objectType: attributes!.objectType as any as string,
  thumbnail: attributes!.thumbnail as any as string | null,
});
